class PacksSelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.productsRadioInputs = this.querySelectorAll(".pack-radio");
    this.slides = this.querySelectorAll(".packs-grid-item");
    this.slidesWrapper = this.querySelector(".packs-grid");
    this.currentWidth = window.innerWidth;
    this.closeDisclaimer = this.querySelector(".close-disclaimer-button");
    this.checkedProduct = this.querySelector('input[name="pack-selection"]:checked');

    this.addEventListeners();
  }

  addEventListeners() {
    this.productsRadioInputs.forEach((input) => {
      input.addEventListener("change", (event) => {
        this.checkPacks(event);
      });
    });
    
    this.closeDisclaimer?.addEventListener("click", () => {
      this.closeDisclaimer.closest(".checkout-button-disclaimer").remove();
    });
  }

  checkPacks(event) {
    document.querySelector("#sidebar-cart").classList.add("loading");
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const productId = event.target.value || this.checkedProduct.value;
        const products = cart.items.filter(
          (item) => item.properties._juneSpinTheWheel === "true"
        );

        const updates = {};

        products.forEach((item) => {
          updates[item.key] = 0;
        });

        const isPackInCart = products.some(
          (item) => item.id === parseInt(productId)
        );
        if (isPackInCart) {
          document.querySelector("#sidebar-cart").classList.remove("loading");
          return;
        }
        fetch(`/cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(productId),
                quantity: 1,
                properties: {
                  _juneSpinTheWheel: "true",
                  Contains: "1 Unreleased + 1 Mystery Shade & more!",
                },
              },
            ],
          }),
        })
          .then((response) => {
            if (!response.ok) {
              return response.json().then((error) => Promise.reject(error));
            }
            return response.json();
          })
          .then(() => {
            if (Object.keys(updates).length > 0) {
              return fetch("/cart/update.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ updates }),
              });
            }
            return Promise.resolve();
          })
          .then((response) => {
            if (response) return response.json();
            return Promise.resolve();
          })
          .then(() => {
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", {
                bubbles: true,
              })
            );
          })
          .catch((error) => {
            console.error("Error updating cart:", error);
          })
          .finally(() => {
            document.querySelector("#sidebar-cart").classList.remove("loading");
          });
      })
      .catch((error) => {
        console.error("Error fetching cart:", error);
      });
  }
}
customElements.define("packs-selector", PacksSelector);
